import { InteractiveContainer } from "@jugl-web/ui-kit";
import { cx, useTranslations } from "@jugl-web/utils";
import { useTheme } from "@web-src/themes/useTheme";

import { useEntitiesListProvider } from "@web-src/modules/entities/providers/EntitiesListProvider/useEntitiesListProvider";
import { ReactComponent as StarsBlueIcon } from "./assets/stars-blue.svg";
import { ReactComponent as StarsDarkIcon } from "./assets/stars-dark.svg";
import { ReactComponent as StarsLightIcon } from "./assets/stars-light.svg";

const themeIcons = {
  dark: <StarsDarkIcon />,
  light: <StarsLightIcon />,
  blue: <StarsBlueIcon />,
};

export const EntityInvitesInfoItem = () => {
  const {
    entityInvitesState: { entityInvites },
  } = useEntitiesListProvider();
  const { t } = useTranslations();
  const { tcx, customTheme } = useTheme();

  const handleClick = (e: React.SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
    document
      .querySelector<HTMLButtonElement>(
        "[data-id=select-entity-popover-trigger]"
      )
      ?.click();
  };

  if (!entityInvites || entityInvites.length === 0) {
    return null;
  }

  return (
    <InteractiveContainer
      className={tcx("flex h-8 items-center gap-2 rounded-lg px-2.5", {
        dark: "bg-[#3E3F40] hover:bg-[#333333]",
        blue: "bg-[#103A84] hover:brightness-90",
        light: "bg-primary-700 hover:brightness-110",
      })}
      onClick={(e) => handleClick(e)}
    >
      <div className={cx("text-sm font-medium text-white")}>
        {t(
          {
            id: "main-navbar-component.entity-invites-2",
            defaultMessage:
              "You have {count} pending {count, plural, one {invite} other {invites}}",
          },
          {
            count: entityInvites?.length || 0,
          }
        )}
      </div>
      {themeIcons[customTheme]}
    </InteractiveContainer>
  );
};
